import React, { useState } from 'react';
import { useTheme } from '../../utils/ThemeSwitcher';
import { MessageSquarePlus } from 'lucide-react';
import FeedbackModal from './FeedbackModal';

/**
 * FeedbackButton Component
 * A floating button that opens the feedback modal.
 * Styled consistently with the Quick Guide toggle button.
 */
const FeedbackButton = ({ 
  userInfo,
  currentView,
  currentProjectId 
}) => {
  const { isDarkMode } = useTheme();
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [isHovered, setIsHovered] = useState(false);

  // Detect mobile
  const isMobile = typeof window !== 'undefined' && window.innerWidth < 768;

  const handleClick = () => {
    setIsModalOpen(true);
  };

  return (
    <>
      {/* Floating Button */}
      <div
        role="button"
        tabIndex={0}
        onClick={handleClick}
        onKeyDown={(e) => { if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); handleClick(); } }}
        onMouseEnter={() => setIsHovered(true)}
        onMouseLeave={() => setIsHovered(false)}
        title="Send Feedback"
        style={{
          position: 'fixed',
          bottom: isMobile ? '60px' : '14px',
          right: '14px',
          zIndex: 9998,
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          width: '36px',
          height: '36px',
          borderRadius: '10px',
          border: `1px solid ${isDarkMode ? 'rgba(255,255,255,0.08)' : 'rgba(0,0,0,0.06)'}`,
          backgroundColor: isDarkMode ? 'rgba(26, 26, 30, 0.9)' : 'rgba(255, 255, 255, 0.95)',
          backdropFilter: 'blur(12px)',
          WebkitBackdropFilter: 'blur(12px)',
          color: isDarkMode ? '#9CA3AF' : '#6B7280',
          cursor: 'pointer',
          boxShadow: isHovered
            ? `0 4px 20px ${isDarkMode ? 'rgba(0,0,0,0.4)' : 'rgba(0,0,0,0.12)'}`
            : `0 2px 10px ${isDarkMode ? 'rgba(0,0,0,0.3)' : 'rgba(0,0,0,0.06)'}`,
          transform: isHovered ? 'scale(1.08)' : 'scale(1)',
          transition: 'all 0.25s cubic-bezier(0.4, 0, 0.2, 1)',
          boxSizing: 'border-box',
        }}
      >
        <MessageSquarePlus 
          size={16} 
          style={{ 
            color: isHovered 
              ? (isDarkMode ? '#F9FAFB' : '#111827') 
              : (isDarkMode ? '#9CA3AF' : '#6B7280'),
            transition: 'color 0.2s ease',
          }} 
        />
      </div>

      {/* Feedback Modal */}
      <FeedbackModal
        isOpen={isModalOpen}
        onClose={() => setIsModalOpen(false)}
        userInfo={userInfo}
        currentView={currentView}
        currentProjectId={currentProjectId}
      />
    </>
  );
};

export default FeedbackButton;